export default "/images/smart_contracts_development/nft_audit_service.png";